<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Árak</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        @click="onCreate"
        icon="el-icon-plus"
      >
        Új Ár
      </el-button>
    </div>
    <el-alert
      v-if="!prices || !prices.length"
      title="Ehhez a partnerhez még nem tartozik ár. Adj hozzá egyet."
      type="info"
      show-icon
      :closable="false"
    />
    <el-table
      v-if="prices && prices.length"
      :data="prices"
    >
      <el-table-column
        prop="product.name"
        label="Termék"
        show-overflow-tooltip
        width="300"
      >
        <template slot-scope="scope">
          {{ scope.row.product.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="price_type.name"
        label="Ártípus"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.price_type.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="Ár"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.price">{{ scope.row.price | currency }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="valid_status"
        label="Státusz"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          <el-tooltip :disabled="!scope.row.valid_from && !scope.row.valid_to" placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
            <div slot="content">
              {{ scope.row.valid_from | date }} - {{ scope.row.valid_to | date }}
            </div>
            <el-tag
              v-if="scope.row.valid_status === 'valid'"
              type="success"
              size="small"
            > Érvényes
            </el-tag>
            <el-tag
              v-if="scope.row.valid_status === 'not_valid'"
              type="danger"
              size="small"
            > Lejárt
            </el-tag>
            <el-tag
              v-if="scope.row.valid_status === 'not_valid_yet'"
              type="primary"
              size="small"
            > Még nem érvényes
            </el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <price-actions
            :price="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="priceFormType === 'add' ? 'Új ár' : 'Ár módosítás'"
      @close="onClose"
      append-to-body
      :close-on-click-modal="false"
      width="600px"
    >
      <price-form
        ref="priceForm"
        :defaultPrice="selectedPrice"
        :formType="priceFormType"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storePrices"
        >
          {{ priceFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  import PriceForm from './Price';
  import PriceActions from './PriceActions';
  import moment from 'moment';

  export default {
    components: {
      PriceForm,
      PriceActions
    },
    props: ['prices'],
    data() {
      return {
        showDialog: false,
        priceFormType: 'add',
        selectedPrice: {},
      };
    },
    methods: {
      onClose() {
        this.$refs.priceForm.price = {};
        this.showDialog = false;
        this.$refs.priceForm.$refs.priceForm.resetFields();
      },
      onCreate() {
        this.priceFormType = 'add';
        this.showDialog = true;
      },
      onUpdate(price) {
        this.selectedPrice = Object.assign({}, price);
        this.priceFormType = 'update';
        this.showDialog = true;
      },
      onDelete(price) {
        const prices = this.prices.filter(a => ((a.id && a.id !== price.id) || a.key !== price.key));
        this.$emit('change', prices);
      },
      async storePrices() {
        const price = Object.assign({}, this.$refs.priceForm.price);
        if(price.valid_from && price.valid_to && moment(price.valid_to).isBefore(moment(price.valid_from))) {
          return this.$messageWrapper.warning('Érvényesség lejárta nem lehet a kezdete előtt');
        }
          price.valid_status = this.getValidStatus(price.valid_from, price.valid_to);
          this.$refs['priceForm'].$refs['priceForm'].validate(valid => {
            if (valid) {
              if (this.priceFormType === 'add') {
                const newPrice = {
                  ...price,
                  key: Math.random().toString(36).substring(7),
                };
                this.$emit('add', newPrice);
              } else {
                const prices = this.prices.map(a => {
                  if ((a.id && a.id === price.id) || (a.key && a.key === price.key)) {
                    return price;
                  } else {
                    return a;
                  }
                });
                this.$emit('change', prices);
              }
              this.showDialog = false;
            }
          });
      },

      getValidStatus(from, to) {
        if(from && !to) {
          if(moment().isAfter(moment(from))) {
            return 'valid';
          } else {
            return 'not_valid_yet';
          }
        }

        if(!from && to) {
          if(moment().isAfter(moment(to))) {
            return 'not_valid';
          } else {
            return 'valid';
          }
        }

        if(!from && !to) {
          return 'valid';
        }

        if(from && to) {
          if(moment().isAfter(moment(to))) {
            return 'not_valid';
          } else if (moment().isBefore(moment(from))) {
            return 'not_valid_yet';
          }
        }
        return 'valid';
      }
    },
  };
</script>
